import { AuthRoot, UnsafeScreenRoot } from "types";

export const AuthRootDefinition: UnsafeScreenRoot = {
  name: AuthRoot,
  routePath: ["/auth/*"],
};
